<template>
  <div class='container'
       ref="containerBox"
       @scroll="handleScroll">
    <div ref="stickyBox"
         :class="[{ sticky: isSticky }, { box: !isSticky }]"
         :style="{ background: isSticky ? '#fff' : 'transparent' }">
      <titlePage :isSticky="isSticky"
                 :scrollToTop="scrollToTop"></titlePage>
    </div>
    <div class='contentBox'>
      <div class="content">
        <div class="list-box flex-column"
             style="margin-top: 30px;">
          <div class="list-item"
               style="display: flex; flex-direction: column;padding: 0;margin-right: 0;">
            <div class="card">
              <div class="title">{{ info.title || '' }}</div>
              <div class="flex-between">
                <div class="flex"
                     style="margin-top: 10px;">
                  <div style="margin-right: 10px;"
                       class="PriceText"> {{ info.pay || '' }} </div>
                  <div class="tags tagsBorder">招{{ info.people || 0 }} 人</div>
                  <div class="tags tagsBorder">{{ info.city_name || '' }}</div>
                  <div class="tags tagsBorder">{{ info.company || '' }}</div>
                </div>
                <div class="flex"
                     style="margin-top: 10px;">
                  <div class="tags flex-column"
                       style="padding: 0 20px;">
                    <p>{{ info.status_1 || 0 }}</p>
                    <p>简历</p>
                  </div>
                  <div class="tags flex-column tagsBorder"
                       style="padding: 0 20px;">
                    <p>{{ info.status_2 || 0 }}</p>
                    <p>面试</p>
                  </div>
                  <div class="tags flex-column tagsBorder"
                       style="padding: 0 20px;">
                    <p>{{ info.status_3 || 0 }}</p>
                    <p>offer</p>
                  </div>
                  <div class="tags flex-column tagsBorder"
                       style="padding: 0 20px;">
                    <p>{{ info.status_4 || 0 }}</p>
                    <p>入职</p>
                  </div>
                  <div class="tags flex-column tagsBorder"
                       style="padding: 0 20px;">
                    <p>{{ info.status_5 || 0 }}</p>
                    <p>过保</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="GradientBackground flex-between"
                 style="border-radius: 0 0 10px 10px;">
              <div class="flex">
                <div class="price"
                     style="margin-right: 20px;">固定金额 {{ info.pay_fee || '' }}</div>
                <div>{{ info.pay_list || '' }}</div>
              </div>
              <div class="flex"
                   style="align-items: center; gap: 12px;">
                <el-button v-if="canCancelOrder(info)"
                           type="text"
                           class="cancel-order-btn"
                           @click="handleCancelOrder">取消接单</el-button>
                <div class="text"
                     style="color: #ADADAD;">{{ info.create_time || '' }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="list-box flex-column"
             style="margin-top: 30px;">
          <div class="list-item"
               style="display: flex; flex-direction: column;padding: 0;margin-right: 0;"
               v-for="(item, index) in info.people_list"
               :key="index">
            <div class="card">
              <div class="flex-between">
                <div class="flex"
                     style="margin-top: 10px;width:40%;">
                  <div class="tags flex-column"
                       style="padding: 0 20px;">
                    <div class="interval">
                      <span>{{ item.name || '' }}</span>
                      <span>{{ item.gender == 1 ? '男' : '女' }}</span>
                      <span>·</span>
                      <span>{{ item.age || 0 }}岁</span>
                      <span>·</span>
                      <span>{{ item.edu || '' }}</span>
                    </div>
                    <div>
                      <span>电话：</span>
                      <span>{{ item.phone || '' }}</span>
                      <span>邮箱：</span>
                      <span>{{ item.email || '' }}</span>
                    </div>
                  </div>
                </div>
                <div class="flex"
                     style="margin-top: 10px;width:300px;">
                  <div class="tags flex-column"
                       style="padding: 0 20px;">
                    <p style="color: #979797;"
                       class="interval">意向城市</p>
                    <p>{{ item.city || '' }}</p>
                  </div>
                  <div class="tags flex-column "
                       style="padding: 0 20px;">
                    <p style="color: #979797;"
                       class="interval">意向岗位</p>
                    <p>{{ item.job || '' }}</p>
                  </div>
                  <div class="tags flex-column "
                       style="padding: 0 20px;">
                    <p style="color: #979797;"
                       class="interval">状态</p>
                    <p>{{ resumeStatusLabel(item) }}</p>
                  </div>
                </div>
                <div class="flex"
                     style="margin-top: 10px;width:20%;">
                  <div class="tags flex-center cursor"
                       style="padding: 0 20px;">
                    <el-image :src="require(`@/static/image/detailes/link.png`)"
                              style="width: 14px;height: 14px;margin-right:4px;"
                              fit="fill"></el-image>
                    <p style="color: #0092FF;"
                       @click="preview(item.resume)">附件简历</p>
                  </div>
                  <div class="tags cursor"
                       style="padding: 0 20px;">
                    <p style="color: #0092FF;"
                       @click="edit(item)">编辑</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div style="margin-top: 50px;"
             class="flex-center">
          <el-button type="primary"
                     plain
                     @click="add">上传简历</el-button>
        </div>
      </div>
      <el-dialog :title="title"
                 :visible.sync="dialogVisible"
                 width="720px"
                 custom-class="order-detail-form-dialog"
                 :before-close="handleClose"
                 :style="{ borderRadius: '16px' }">
        <div class="formBox">
          <el-form label-position="top"
                   label-width="80px"
                   :model="formLabelAlign"
                   ref="formLabelAlign">
            <div class="flex-between form-dialog-row">
              <el-form-item label="姓名"
                            required>
                <el-input v-model="formLabelAlign.name"></el-input>
              </el-form-item>
              <el-form-item label="电话"
                            required>
                <el-input v-model="formLabelAlign.phone"></el-input>
              </el-form-item>
            </div>
            <div class="flex-between form-dialog-row">
              <el-form-item label="性别"
                            required>
                <div class="gender-btn-group">
                  <el-button :type="formLabelAlign.gender == item.id ? 'primary' : ''"
                             plain
                             size="small"
                             class="gender-btn"
                             v-for="(item, index) in sexList"
                             :key="index"
                             @click="formLabelAlign.gender = item.id">{{
                      item.name || ''
                    }}</el-button>
                </div>
              </el-form-item>
              <el-form-item label="邮箱"
                            required>
                <el-input v-model="formLabelAlign.email"></el-input>
              </el-form-item>
            </div>
            <div class="flex-between form-dialog-row">
              <el-form-item label="年龄"
                            required>
                <!-- <el-date-picker v-model="formLabelAlign.birth" type="date" placeholder="选择出生年月" style="width: 100%;">
                </el-date-picker> -->
                <el-input v-model="formLabelAlign.age"></el-input>
              </el-form-item>
              <el-form-item label="意向城市"
                            required>
                <!-- <el-input v-model="formLabelAlign.city"></el-input> -->
                <el-select v-model="formLabelAlign.city_id"
                           filterable
                           placeholder="请选择">
                  <el-option v-for="item in CityList"
                             :key="item.id"
                             :label="item.title"
                             :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="flex-between form-dialog-row">
              <el-form-item label="学历"
                            required>
                <el-select v-model="formLabelAlign.edu"
                           placeholder="请选择你的学历"
                           style="width: 100%;">
                  <el-option v-for="item in eduList"
                             :key="item.value"
                             :label="item.label"
                             :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="意向岗位"
                            required>
                <el-input v-model="formLabelAlign.job"></el-input>
              </el-form-item>
            </div>
            <div class="form-dialog-row-full">
              <el-form-item label="上传简历"
                            required>
                <div class="resume-upload-row">
                  <el-input v-model="formLabelAlign.resume"
                            disabled
                            placeholder="选择文件后显示地址"></el-input>
                  <el-upload class="resume-uploader"
                             action="#"
                             :on-remove="handleRemove"
                             :before-upload="beforeUpload"
                             :on-error="handleError"
                             :limit="2"
                             :on-exceed="handleExceed"
                             :file-list="fileList"
                             accept="file"
                             :http-request="uploadFile">
                    <el-button size="small"
                               type="primary"
                               plain>选择文件</el-button>
                  </el-upload>
                </div>
              </el-form-item>
            </div>
            <div class="form-dialog-row-full">
              <el-form-item label="上传照片">
                <div class="flex">

                  <div style="width: 94px;border-radius: 6px;height: 128px;margin-right: 50px;border: 1px solid #E4E8EB;"
                       v-if="!dialogImageUrl"></div>
                  <el-image :src="dialogImageUrl"
                            style="width: 94px;border-radius: 6px;height: 128px;margin-right: 50px;"
                            fit="fill"
                            v-else
                            @click="dialogImage = true"></el-image>
                  <el-upload :action="picUploadURL"
                             :on-remove="handleRemovePic"
                             :before-upload="beforePicUpload"
                             :on-error="handleError"
                             :limit="2"
                             :on-exceed="handleExceed"
                             :file-list="picList"
                             accept="file"
                             :http-request="uploadFilePic">
                    <div style="text-align: left;">
                      <div class="el-upload__text">请上传您的照片</div>
                      <div class="el-upload__text">支持jpg jpeg png gif格式照片，大小不超过2M</div>
                      <el-button type="primary">上传照片</el-button>
                    </div>
                  </el-upload>
                </div>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div slot="footer"
             class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary"
                     @click="submitForm('formLabelAlign')">完成</el-button>
        </div>
      </el-dialog>
      <el-dialog :append-to-body="true"
                 :visible.sync="dialogImage"
                 id="dialogImageUrl">
        <img width="200px"
             :src="dialogImageUrl"
             alt="" />
      </el-dialog>
    </div>
    <fotterVue></fotterVue>
  </div>
</template>

<script>
import config from '@/config/config'
import titlePage from '@/components/titlePage.vue'
import fotterVue from '@/components/fotter.vue'
import {
  canCancelOrder,
  confirmCancelOrder,
} from '@/utils/order'
const STAGES = [
  { n: 1, name: '邀约' },
  { n: 2, name: '面试' },
  { n: 3, name: 'offer' },
  { n: 4, name: '入职' },
  { n: 5, name: '保期' },
]
export default {
  name: '',
  components: {
    titlePage,
    fotterVue,
  },
  data() {
    return {
      typeList: [
        // { name: "销售人员", src: "image/index/icon1" },
        { name: '销售人员', src: 'require(`@/static/image/index/icon1.png`)' },
        { name: '销售人员', src: 'require(`@/static/image/index/icon2.png`)' },
        { name: '销售人员', src: 'require(`@/static/image/index/icon3.png`)' },
        { name: '销售人员', src: 'require(`@/static/image/index/icon4.png`)' },
        { name: '销售人员', src: 'require(`@/static/image/index/icon5.png`)' },
        { name: '销售人员', src: 'require(`@/static/image/index/icon6.png`)' },
      ],
      dialogVisible: false,
      formLabelAlign: {
        gender: 2,
        resume: '',
        name: '',
        phone: '',
        email: '',
        job: '',
        edu: '',
        city_id: '',
        pic: '',
        age: '',
      },
      rules: {
        // gender: [{ required: true, message: '请选择性别', trigger: 'change' }],
        // // resume: [{ required: true, message: '请上传简历', trigger: 'blur' }],
        // name: [{ required: true, message: '请填写姓名', trigger: 'blur' }],
        // phone: [{ required: true, message: '请填写电话', trigger: 'blur' }],
        // email: [{ required: true, message: '请填写邮箱', trigger: 'blur' }],
        // job: [{ required: true, message: '请填写岗位', trigger: 'blur' }],
        // edu: [{ required: true, message: '请选择学历', trigger: 'change' }],
        // // city: [{ required: true, message: '请选择城市', trigger: 'change' }],
        // // pic: [{ required: true, message: '请上传图片', trigger: 'change' }],
        // age: [{ required: true, message: '请填写年龄', trigger: 'blur' }],
      },
      sexList: [
        {
          name: '男',
          id: 1,
        },
        {
          name: '女',
          id: 2,
        },
      ],
      eduList: [
        {
          value: '0',
          label: '初中及以下',
        },
        {
          value: '1',
          label: '高中',
        },
        {
          value: '2',
          label: '大专',
        },
        {
          value: '3',
          label: '本科',
        },
        {
          value: '4',
          label: '研究生',
        },
        {
          value: '5',
          label: '博士',
        },
      ],
      objClass: {
        upLoadShow: true,
        upLoadHide: false,
      },
      fileList: [],
      picList: [],
      dialogImage: false,
      dialogImageUrl: '',
      info: {},
      picUploadURL: config.config + '/api.php/Common/upload',
      fileType: '',
      isSticky: false,
      stickyBoxTop: 0,
      title: '',
      CityList: [],
    }
  },
  computed: {},
  watch: {},
  methods: {
    canCancelOrder,
    handleCancelOrder() {
      confirmCancelOrder(this, this.info)
        .then(() => this.$api.index.cancelOrder({ id: this.id }))
        .then((res) => {
          if (res && res.code == 200) {
            this.$message.success(res.msg || '已取消接单')
            this.$router.push('/MyOrder')
          }
        })
        .catch(() => {})
    },
    getCityIndex() {
      this.$api.index.CityIndex().then((res) => {
        if (res.code == 200) {
          console.log(res.data.list, 'res.data.list')

          for (let i in res.data.list) {
            res.data.list[i].map((item) => {
              // console.log(item);
              this.CityList.push(item)
            })
          }
          console.log(this.CityList, 'this.CityList')
        }
      })
    },
    parsePay(pay) {
      if (!pay) return {}
      try {
        return typeof pay === 'string' ? JSON.parse(pay) : pay
      } catch (e) {
        return {}
      }
    },

    /** 单条简历：右侧「状态」文案 */
    resumeStatusLabel(item) {
      const pay = this.parsePay(item.pay)
      console.log(pay, 'pay')
      if (pay.reject == 1) return '已作废'
      if (+item.fail_stage > 0) {
        const s = STAGES.find((x) => x.n === +item.fail_stage)
        return s ? s.name + '失败' : '已失败'
      }
      let stage = 0
      for (let n = 5; n >= 1; n--) {
        if (+item['status_' + n] === 1) {
          stage = n
          break
        }
      }
      if (stage === 0) return '已投递' // 还没有任何一个状态通过
      const s = STAGES.find((x) => x.n === stage)
      return s ? s.name : '已投递'
    },

    /** 单条简历：顶部 5 格数字（若要在每人卡片上展示节点人数，用 0/1 显示是否通过） */
    resumeStageCount(item, n) {
      return +item['status_' + n] === 1 ? 1 : 0
    },
    handleClick(tab, event) {
      console.log(tab, event)
    },
    edit(item) {
      this.title = '编辑资料信息'
      this.formLabelAlign = item
      this.dialogVisible = true
      if (item.pic) {
        this.dialogImageUrl = config.imgUrl + item.pic
        this.formLabelAlign.pic = item.pic
      }
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then((_) => {
          done()
        })
        .catch((_) => {})
    },
    /* // 上传照片 */
    // 移除
    // handleRemove(file) {
    //   this.formLabelAlign.fileUri = "";
    //   const index = this.fileList.findIndex((e) => e.uid === file.uid);
    //   this.fileList.splice(index, 1);
    //   this.objClass.upLoadShow = true; //删除图片后显示上传框
    //   this.objClass.upLoadHide = false;
    // },
    // // 放大
    // handlePictureCardPreview(file) {
    //   this.dialogImageUrl = file.url;
    //   this.dialogImage = true;
    // },
    // handleExceed(files, fileList) {
    //   this.$message.warning(
    //     `当前限制选择 1 个图片，本次选择了 ${files.length} 个图片，共选择了 ${files.length + fileList.length
    //     } 个图片`
    //   );
    // },
    // // 选取完文件触发事件
    // onChange(file, fileList) {
    //   // this.fileList = fileList;
    //   this.formLabelAlign.fileUri = file.url;
    //   // this.objClass.upLoadHide = true; //上传图片后置upLoadHide为真，隐藏上传框
    //   // this.objClass.upLoadShow = false;
    //   // this.$refs.upload.submit(); // 触发:http-request="uploadFile"
    //   // this.length = fileList.length;
    //   // this.UpdateUrl = this.ruleForm.url;
    //   // this.$emit("UpdateUrl", this.UpdateUrl);
    // },

    handleRemove(file, fileList) {
      console.log(file, fileList)
      this.dialogImageUrl = ''
      this.formLabelAlign.pic = ''
    },
    beforeUpload(file) {
      console.log(
        'beforeUpload',
        file,
        this.filFeList,
        file.name,
        file.name.split('.')[1]
      )
      this.fileList = [file]
      this.fileType = file.name.split('.')[1]

      if (
        this.fileType !== 'pdf' &&
        this.fileType !== 'doc' &&
        this.fileType !== 'docx'
      ) {
        this.$message.error(`请上传word文档/pdf文件`)
        return false
      }
    },
    handleError(err, file) {
      this.$message.error(`${file.name} 文件上传失败`)
    },
    handleExceed(files, fileList) {
      console.log(files, fileList, 'files, fileList')
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      )
    },
    uploadFile({ file, onSuccess, onError }) {
      const formData = new FormData()
      formData.append('file', file)
      formData.append('dir', this.fileType)
      formData.append('type', this.fileType)
      this.$api.index.uploadFile(formData).then((res) => {
        if (res.code == 200) {
          this.formLabelAlign.resume = res.data.url
        } else if (res.code == 401) {
          this.$message.error('登录失效请重新登录')
        } else {
          this.$message.error(res.msg)
        }
      })
    },

    // 上传图片
    uploadFilePic({ file, onSuccess, onError }) {
      const formData = new FormData()
      formData.append('file', file)
      formData.append('dir', 'img')
      formData.append('type', 'img')
      this.$api.index.picUpload(formData).then((res) => {
        if (res.code == 200) {
          this.dialogImageUrl = config.imgUrl + res.data.url
          this.formLabelAlign.pic = res.data.url
        } else if (res.code == 401) {
          this.$message.error('登录失效请重新登录')
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    beforePicUpload(file) {
      console.log('beforePicUpload', file, this.filFeList)
      this.picList = [file]
    },
    handleRemovePic(file, fileList) {
      console.log(file, fileList)
      this.dialogImageUrl = ''
      this.formLabelAlign.pic = ''
    },
    getInfo() {
      this.$api.index.getOrderInfo({ id: this.id }).then((res) => {
        console.log(res, '666')
        this.loading = false
        if (res.code == 200) {
          this.info = res.data
        }
      })
    },
    preview(url) {
      const type = this.getLastPart(url)
      console.log(type, 'ttt')
      if (type == 'pdf') {
        window.open(config.config + url)
        //  this.$router.push({
        //   path: '/pdf', query: {
        //     wordURL: config.config + url
        //   }
        // });
      } else {
        window.open('https://view.xdocin.com/view?src=' + config.config + url)
        // this.$router.push({
        //   path: '/file', query: {
        //     wordURL: config.config + url
        //   }
        // });
      }
    },
    getLastPart(str) {
      const parts = str.split('.')
      return parts[parts.length - 1]
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.formLabelAlign.gender) {
            this.$message.warning('请选择性别')
            return
          }
          if (!this.formLabelAlign.resume) {
            this.$message.warning('请上传简历')
            return
          }
          if (!this.formLabelAlign.name) {
            this.$message.warning('请填写姓名')
            return
          }
          if (!this.formLabelAlign.phone) {
            this.$message.warning('请填写电话')
            return
          }
          if (!this.formLabelAlign.email) {
            this.$message.warning('请填写邮箱')
            return
          }
          if (!this.formLabelAlign.job) {
            this.$message.warning('请填写岗位')
            return
          }
          if (!this.formLabelAlign.edu) {
            this.$message.warning('请选择学历')
            return
          }
          if (!this.formLabelAlign.city_id) {
            this.$message.warning('请选择城市')
            return
          }
          // if (!this.formLabelAlign.pic) {
          //   this.$message.warning('请上传图片')
          //   return
          // }
          if (!this.formLabelAlign.age) {
            this.$message.warning('请输入年龄')
            return
          }
          this.submit()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    submit() {
      // if (!this.formLabelAlign.resume) {
      //   this.$message.warning('请上传简历')
      //   return
      // }
      // if (!this.formLabelAlign.city) {
      //   this.$message.warning('请输入城市')
      //   return
      // }
      // if (!this.formLabelAlign.age) {
      //   this.$message.warning('请输入年龄')
      //   return
      // }
      if (this.formLabelAlign.id) {
        this.$api.index.updateResume(this.formLabelAlign).then((res) => {
          console.log(res, '666')
          if (res.code == 200) {
            this.dialogVisible = false
            this.resetForm('formLabelAlign')
            this.getInfo()
          }
        })
      } else {
        this.formLabelAlign.id = this.info.id
        this.$api.index.uploadResume(this.formLabelAlign).then((res) => {
          console.log(res, '666777')
          if (res.code == 200) {
            this.dialogVisible = false
            this.getInfo()
          }
        })
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    handleScroll(event) {
      const scrollTop = event.target.scrollTop
      this.isSticky = scrollTop > this.stickyBoxTop
    },
    scrollToTop() {
      this.$refs.containerBox.scrollTop = 0
    },
    add() {
      this.formLabelAlign = {
        gender: 2,
        resume: '',
        name: '',
        phone: '',
        email: '',
        job: '',
        edu: '',
        city_id: '',
        pic: '',
        age: '',
      }
      this.title = '添加资料信息'
      this.dialogVisible = true
    },
  },
  created() {},
  mounted() {
    this.scrollToTop()
    this.id = this.$route.query.id
    this.getInfo()
    this.getCityIndex()
  },
}
</script>
<style lang='scss' scoped>
.contentBox {
  background: linear-gradient(0deg, #f6f8fe 0%, #f6f8fe 78%, #ceeaff 100%);
  margin-top: 60px;
  min-height: 55vh;
}

.content {
  padding: 30px 0;
}

.tags {
  font-weight: 500;
  font-size: 14px;
  color: #333333;
  padding: 0 10px;

  p {
    margin: 0;
    padding: 0;

    &:last-child {
      color: #666;
    }
  }
}

.tagsBorder {
  border-left: 1px solid #d7d7d7;
}

span {
  margin-right: 10px;
}

.interval {
  margin-bottom: 10px !important;
}

.formBox {
  max-height: calc(100vh - 220px);
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 2px;

  .form-dialog-row {
    display: flex;
    gap: 16px;
    align-items: flex-start;

    > .el-form-item {
      flex: 1 1 0;
      min-width: 0;
      margin-bottom: 14px;
    }
  }

  .form-dialog-row-full > .el-form-item {
    flex: 1 1 100%;
    width: 100%;
    margin-bottom: 14px;
  }

  .gender-btn-group {
    display: flex;
    gap: 10px;

    .gender-btn {
      flex: 1;
      margin: 0;
    }
  }

  .resume-upload-row {
    display: flex;
    align-items: center;
    gap: 12px;

    .el-input {
      flex: 1;
      min-width: 0;
    }
  }
}

.formBox::-webkit-scrollbar {
  width: 6px;
}

.formBox::-webkit-scrollbar-thumb {
  background: #dcdfe6;
  border-radius: 3px;
}

::v-deep .order-detail-form-dialog .el-dialog__header {
  padding: 16px 20px 10px;
}

::v-deep .order-detail-form-dialog .el-dialog__body {
  padding: 6px 20px 4px;
}

::v-deep .order-detail-form-dialog .el-dialog__footer {
  padding: 10px 20px 16px;
}

::v-deep .order-detail-form-dialog .el-form-item__label {
  padding-bottom: 4px;
  line-height: 1.35;
}

::v-deep .el-input.is-disabled .el-input__inner {
  color: #333333;
  background-color: transparent;
}

::v-deep .el-select {
  width: 100%;
}
::v-deep .el-dialog {
  border-radius: 10px;
  overflow-x: hidden;
}

::v-deep .order-detail-form-dialog .el-dialog__body {
  overflow-x: hidden;
}

.cancel-order-btn {
  color: #f56c6c !important;
  padding: 0 4px;
  font-size: 13px;
}
</style>